import { format, parseISO } from "date-fns";
import { FC } from "react";
import { UseFormGetValues } from "react-hook-form";

import { AddCaseProps } from "src/pages/addCase/types";


export type DiureticsInformationProps = {
  getValues: UseFormGetValues<AddCaseProps>;
};



const ShowDiureticsInformation: FC<DiureticsInformationProps> = ({ getValues }): JSX.Element => {
  const { prescription_information_attributes: { cp_diuretics, applicable_to_patient, reasons_alternative_insulins_not_effective, last_fev1_date } } = getValues()

  const meds = ["Other", "Novolog", "Humulin", "Fiasp", "Aspart", "Lispro", "Apidra", "Two Orals Anti-diabetics"];

  const diuretics =
    (cp_diuretics?.diuretics_tried as Record<string, any>) || {};

  const normalize = (name: string) =>
    name.toLowerCase().replace(/\s+/g, "_").replace(/-/g, "_");

  const cp_diuretic = meds
    .filter((med) => diuretics[normalize(med)])
    .map((med) => {
      const key = normalize(med);
      const props = (diuretics[`${key}_props`] || {}) as Record<string, any>;
      const failureReason = props[`${key}_failure_reason`] || "";
      const failureReasonOther = props[`${key}_failure_reason_other`] || "";

      return {
        drug_name: key === "other" ? (props.other_name || med) : med,
        failure_reason: failureReason === "Other" ? failureReasonOther : failureReason,
        date_tried: props[`${key}_tried_date`] || "",
      };
    });

  const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
    <div style={{ marginBottom: "20px" }}>
      <h5 className="text-primary">
        {title}
      </h5>
      {children}
    </div>
  );
  return (

    <div className="card">
      <div className="card-header">
        <h1 className="m-0">Current and Prior Treatment</h1>
      </div>
      <div className={"card-body"}>
        <div className="row">
          <div>
            {/* 🔹 Prior Treatment */}
            <Section title="Prior Treatment">
              <div className="table-responsive-sm table-responsive-md table-responsive-lg">
                <table className="table table-striped table-sm">
                  <thead>
                  <tr className="text-center">
                    <th>Drug</th>
                    <th>Failure Reason</th>
                    <th>Date Tried</th>
                  </tr>
                  </thead>
                  <tbody>
                  {cp_diuretic.length > 0 ? (
                      cp_diuretic.map((item, i) => (
                          <tr key={i} className="text-center">
                            <td>{item.drug_name}</td>
                            <td>{item.failure_reason || "-"}</td>
                            <td>{item.date_tried && format(parseISO(item.date_tried), 'MM/dd/yyyy')}</td>
                          </tr>
                      ))
                  ) : (
                      <tr>
                        <td colSpan={3} style={{ textAlign: "center" }}>
                          No Prior Treatment Found
                        </td>
                      </tr>
                  )}
                  </tbody>
                </table>
              </div>
            </Section>

            {/* 🔹 Reasons */}
            <Section title="Reasons Alternative Insulins Not Effective">
              {reasons_alternative_insulins_not_effective && reasons_alternative_insulins_not_effective?.main?.length > 0 &&
                reasons_alternative_insulins_not_effective.main.map((reason, i) => {

                  const isNeedlePhobia =
                    reason === "Needle Phobia and unable to self-inject";

                  return (
                    <div key={i}>
                      <p className="mb-2"><i className="bi bi-check-all text-primary"></i>{reason}</p>

                      {isNeedlePhobia &&
                        reasons_alternative_insulins_not_effective?.needle_phobia?.length > 0 && (
                          <ul>
                            {reasons_alternative_insulins_not_effective.needle_phobia.map(
                              (sub, idx) => (
                                <p className="m-0" key={idx}><i className="bi bi-check-all text-primary"> </i>{sub}</p>
                              )
                            )}
                          </ul>
                        )}
                    </div>
                  );
                })}
            </Section>

            {/* 🔹 Applicable */}
            <Section title="Applicable to Patient">
              <ul>
                {applicable_to_patient && applicable_to_patient.map((item, i) => (
                  <p className="mb-2" key={i}><i className="bi bi-check-all text-primary"></i>{item}</p>
                ))}
              </ul>
            </Section>

            {/* 🔹 Additional */}
            <Section title="Additional Info">
              <p>
                <strong>Date of Last FEV1:</strong>{" "}
                {last_fev1_date &&  format(new Date(last_fev1_date), 'MM/dd/yyyy')}
              </p>
            </Section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ShowDiureticsInformation;
